// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-detail-modal{max-width:1200px;max-height:600px;overflow:hidden}.product-detail-modal .product-detail-modal-inner{height:100%;overflow:hidden}.product-detail-modal .product-details{height:100%;overflow:auto}@media screen and (max-width: 991px){.product-detail-modal{overflow:auto;max-height:100%}.product-detail-modal .product-detail-modal-inner{height:auto;overflow:auto}.product-detail-modal .product-details{height:auto}}", ""]);
// Exports
module.exports = exports;
